import { FormGroup } from '@/components/FormGroup';

import Details from './Details';

const ProductPaymentMethods = () => {
  return (
    <FormGroup collapsable={true} showValidationState={true} reviewMode={false}>
      <Details />
    </FormGroup>
  );
};

export default ProductPaymentMethods;
